"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TextButton = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/action/TextButton"));
var _Body = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/primitive/Body"));
var _Title = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/primitive/Title"));
var _grid = require("@rebass/grid");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _createPlaceholder = _interopRequireDefault(require("../utils/createPlaceholder"));
var _UnitThumbnail = _interopRequireDefault(require("./designsystem/UnitThumbnail"));
var _Divider = _interopRequireDefault(require("./Divider"));
var _Loading = _interopRequireDefault(require("./Loading"));
var _SummaryBar = _interopRequireDefault(require("./SummaryBar"));
var _SummaryBarItem = _interopRequireWildcard(require("./SummaryBarItem"));
var _TenantContext = require("../context/TenantContext");
var _router = require("next/router");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TitleWrapper = _interopRequireDefault(require("./designsystem/TitleWrapper"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
const LeaveReview = ({
  item,
  object,
  webpThumbnail,
  jpegThumbnail,
  locale,
  isAnonymous,
  loading,
  pushUrl,
  strapline,
  subtitle
}) => {
  const {
    brandConfig
  } = (0, _TenantContext.useTenantContext)();
  const {
    push
  } = (0, _router.useRouter)();
  return __jsx(_grid.Flex, {
    flexDirection: ['column', null, 'row'],
    justifyContent: "space-between"
  }, __jsx(_grid.Box, {
    order: 1,
    mr: [null, null, 5, 8]
  }, __jsx(StyledTitleWrapper, {
    title: __jsx(_reactIntl.FormattedMessage, {
      id: "Nu7jsd",
      defaultMessage: [{
        "type": 0,
        "value": "Je beoordeling"
      }]
    })
  }), __jsx(Description, null, __jsx(_reactIntl.FormattedMessage, {
    id: "LwydMc",
    defaultMessage: [{
      "type": 0,
      "value": "Wat fijn dat je de tijd neemt om een beoordeling te geven van je accommodatie. Je kunt hiervoor onderstaand formulier gebruiken."
    }]
  }), __jsx("br", null), __jsx("br", null), __jsx(_reactIntl.FormattedMessage, {
    id: "1GczhI",
    defaultMessage: [{
      "type": 0,
      "value": "Je beoordeling wordt op de website onder de door jouw beoordeelde accommodatie getoond. We vermelden daarbij alleen je woonplaats en de maand waarin je te gast was."
    }]
  }), __jsx("br", null), __jsx("br", null), __jsx(_reactIntl.FormattedMessage, {
    id: "9kCIiI",
    defaultMessage: [{
      "type": 0,
      "value": "De eigenaar van de accommodatie wordt geïnformeerd dat je een beoordeling hebt gegeven en mag een reactie geven op je beoordeling. Ook deze eventuele reactie tonen we op onze website."
    }]
  })), __jsx(_grid.Box, {
    my: [5, 7]
  }, __jsx(_Title.default, {
    elementType: "h3",
    variant: "small"
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "kTCiHG",
    defaultMessage: [{
      "type": 0,
      "value": "Heb je een klacht?"
    }]
  })), __jsx(Description, null, __jsx(_reactIntl.FormattedMessage, {
    id: "KFAg2m",
    defaultMessage: [{
      "type": 0,
      "value": "Hopelijk was alles naar wens in de accommodatie. Toch horen we het ook graag als dat niet zo is. Vul dan "
    }, {
      "type": 1,
      "value": "complaintForm"
    }, {
      "type": 0,
      "value": " in. Wij geven je klacht direct door aan de verhuurder. Uiterlijk binnen twee weken ontvangt je een reactie."
    }],
    values: {
      complaintForm: __jsx(_TextButton.default, {
        style: {
          display: 'inline-flex'
        },
        as: "a",
        href: brandConfig.complaintFormUrl[locale],
        target: "_blank",
        rel: "noreferrer noopener"
      }, __jsx(_reactIntl.FormattedMessage, {
        id: "Cnhp1E",
        defaultMessage: [{
          "type": 0,
          "value": "het klachtenformulier"
        }]
      }))
    }
  }))), __jsx(_Divider.default, {
    className: "lt-s",
    mb: 6
  })), isAnonymous ? __jsx(_grid.Box, {
    order: 1,
    mb: 6,
    ml: [3, null, 4],
    width: [1, null, '60%']
  }, loading && __jsx(_grid.Box, null, __jsx(_UnitThumbnail.default, {
    loading: true
  }), __jsx(_Loading.default, {
    mt: 4,
    spacing: 3
  })), object?.__typename === 'RentalUnit' && __jsx(_SummaryBarItem.default, {
    thumbnail: __jsx(_SummaryBarItem.SummaryBarItemThumbnail, {
      isClickable: true,
      onClick: () => {
        push(pushUrl);
      },
      title: object.name,
      thumbnail: {
        sources: [{
          srcSet: webpThumbnail?.transform?.srcSet,
          type: 'image/webp'
        }, {
          srcSet: jpegThumbnail?.transform?.srcSet,
          type: 'image/jpeg'
        }],
        fallback: {
          src: jpegThumbnail?.transform?.src
        },
        placeholder: (0, _createPlaceholder.default)(webpThumbnail?.transform?.placeholder)
      },
      strapline: strapline,
      subTitle: __jsx(_SummaryBarItem.SummaryBarItemBody, {
        style: {
          textTransform: 'capitalize'
        },
        title: subtitle
      }, subtitle)
    })
  }, __jsx(_SummaryBarItem.SummaryBarItemField, {
    title: __jsx(_reactIntl.FormattedMessage, {
      id: "B0YRgl",
      defaultMessage: [{
        "type": 0,
        "value": "# Accommodatie"
      }]
    })
  }, __jsx(_Body.default, {
    variant: "small"
  }, object.code)))) : __jsx(_grid.Box, {
    order: 1,
    mb: 6,
    ml: [3, null, 4],
    width: [1, null, '60%']
  }, __jsx(_SummaryBar.default, {
    data: item,
    showOnMobile: true,
    hidePrices: true
  })));
};
var _default = exports.default = LeaveReview;
const StyledTitleWrapper = (0, _styledComponents.default)(_TitleWrapper.default).withConfig({
  displayName: "LeaveReview__StyledTitleWrapper",
  componentId: "txm76o-0"
})(["@media screen and (min-width:", "){text-align:unset;}"], ({
  theme
}) => theme.mediaQueries.s);
const Description = (0, _styledComponents.default)(_Body.default).withConfig({
  displayName: "LeaveReview__Description",
  componentId: "txm76o-1"
})(["margin-top:1.9rem;@media screen and (min-width:", "){margin-top:2.7rem;}"], ({
  theme
}) => theme.mediaQueries.m);